import type { Goal } from "instantdb/types";

export const STRESS_GOALS: Partial<Goal>[] = [
  {
    id: "build-stress-resilience",
    symbol: "🧠",
    title: "Build Stress Resilience",
    description: "Develop techniques to effectively manage daily stressors",
  },
  {
    id: "create-stress-free-routines",
    symbol: "⏱️",
    title: "Create Stress-Free Routines",
    description: "Establish daily practices that reduce anxiety and tension",
  },
  {
    id: "practice-mindful-relaxation",
    symbol: "🌿",
    title: "Practice Mindful Relaxation",
    description: "Learn methods to calm your mind and body during stressful moments",
  },
  {
    id: "improve-sleep-during-stressful-periods",
    symbol: "💤",
    title: "Improve Sleep During Stressful Periods",
    description: "Develop strategies to maintain good sleep despite life's pressures",
  },
];
